import { render, staticRenderFns } from "./VideoPlayDialog.vue?vue&type=template&id=4c23fad2"
import script from "./videoPlayDialog.js?vue&type=script&lang=js&external"
export * from "./videoPlayDialog.js?vue&type=script&lang=js&external"
import style0 from "./VideoPlayDialog.vue?vue&type=style&index=0&id=4c23fad2&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/jenkins_workspace/workspace/vuejs-tb-train-ontraining-web-sim/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c23fad2')) {
      api.createRecord('4c23fad2', component.options)
    } else {
      api.reload('4c23fad2', component.options)
    }
    module.hot.accept("./VideoPlayDialog.vue?vue&type=template&id=4c23fad2", function () {
      api.rerender('4c23fad2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/video-play-dialog/VideoPlayDialog.vue"
export default component.exports